import React, { useState, useRef, useEffect } from "react";
import { LEAD_INFORMATION, PRIORITY } from "../../../Dropdownmanager";
import { getOptionsByPath } from "../../../utilsdata";
import { Form } from 'antd';
import AdminTaskFilter from './AdminTaskFilter';
import { Col, Modal, Row, message, Pagination, Dropdown, Menu } from "antd";
import { setLoader } from "../../../Slices/loaderSlice";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter, faCloudDownload, faTrash, faUserEdit, faEye, faCheck } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from "react-redux";
import axios from "axios";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { SERVER_URL } from "../../../databucket";
import { AntdButton } from "../../../blueplanitUtils/InputField";
import AddIssueForm from "./AddIssueForm";
import EditIssueForm from "./EditIssueForm";
import { CustomGridTable } from "../../../blueplanitUtils/CustomGridTable";
import ViewTask from "./ViewTask";
import { getAllIssuesThunk, createIssueThunk, updateIssueThunk, deleteIssueThunk } from "../../../Slices/IssueSlice";
import { getEmployeesListThunk } from "../../../Slices/Thunk/getemployeelist";
 
dayjs.extend(utc);
dayjs.extend(timezone);
 
const AdminIssues = () => {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
    const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
    const [showForm, setShowForm] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [filterForm] = Form.useForm();
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [isDisabled, setIsDisabled] = useState(false);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const [originalIssue, setOriginalIssue] = useState(null);
    const [isChanged, setIsChanged] = useState(false);
    const [formData, setFormData] = useState({
        Tabname: "",
        TaskTitle: "",
        Priority: "Low",
        issuedescription: "",
        Deadline: "",
        UpdatedDate: "",
        CreatedBy: "",
        GuidedBy: "",
        Status: "Not Started",
        TechStack: "",
        CodeSnippet: "",
        HoursSpent: "",
        Assignedto: "",
        Remarks: ""
    });
    const [issues, setIssues] = useState([]);
    const [selectedIssue, setSelectedIssue] = useState(null);
    const [allIssues, setAllIssues] = useState([]);
    const [filters, setFilters] = useState({});
    const [editingIssue, setEditingIssue] = useState(null);
    const [record, setRecord] = useState({});
    const [fileData, setFileData] = useState(null);
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(false);
 
    const usersList = useSelector((state) => state.employee.AllEmployees);
//     const { list: usersList = [], loading: empLoading } = useSelector(
//     (state) => state.employees
// );
 
const getEmployeeName = (value) => {
    if (!value) return "—";
 
    // Check if this is a valid MongoDB ObjectId
    const isObjectId = /^[0-9a-fA-F]{24}$/.test(value);
 
    if (isObjectId) {
        const emp = usersList.find((u) => u._id === value);
        return emp ? `${emp.firstname} ${emp.lastname}` : value;
    }
 
    // If not an ID → it's already a name
    return value;
};
 
 
    const assignToUsers = usersList.filter(
        (user) => user.employeestatus === "Active"
    );
   
    useEffect(() => {
//    dispatch(getEmployeesListThunk());  // <-- Added this
   fetchAllIssues();
}, []);
 
   
 
   
    const fetchAllIssues = async () => {
        try {
            setLoading(true);
            dispatch(setLoader(true));
            const result = await dispatch(getAllIssuesThunk()).unwrap();
 
            const formattedIssues = result.map((issue, index) => ({
                key: index,
                id: issue?._id,
                TaskID: issue?.TaskID || issue?.taskId || "",
                Tabname: issue.Tabname || "",
                TaskTitle: issue.TaskTitle || "",
                TechStack: issue.TechStack || "",
                CodeSnippet: issue.CodeSnippet || "",
                HoursSpent: issue.HoursSpent || "",
               CreatedBy: issue.CreatedBy,      // keep ID
    GuidedBy: issue.GuidedBy,          
                Priority: issue.Priority || "",
                Deadline: issue.Deadline || "",
                issuedescription: issue.issuedescription || issue.description || "",
                DateAndTime: issue.DateAndTime,
                UpdatedDate: issue.UpdatedDate,
                Status: issue.Status || "",
                Assignedto: Array.isArray(issue.Assignedto)
        ? issue.Assignedto
        : issue.Assignedto
        ? [issue.Assignedto]
        : [],
                Remarks: issue.Remarks || "",
                fileNames: issue.fileNames,
                urls: issue.urls,
                Instructions: issue.Instructions,
                QualityScore: issue.QualityScore,
                FinalRemarks: issue.FinalRemarks
            }));
 
            setIssues(formattedIssues);
            setAllIssues(formattedIssues);
           
        } catch (error) {
            console.error("Error fetching issues:", error);
            message.error("Failed to fetch issues. Please try again.");
        } finally {
            setLoading(false);
            dispatch(setLoader(false));
        }
    };
 
    const startTimer = () => {
        setIsDisabled(true);
        setTimeout(() => {
            setIsDisabled(false);
        }, 5000);
    };
 
    const closeViewModal = () => {
        setSelectedIssue(null);
        setIsViewModalOpen(false);
    };
 
    const getAssignToUsers = (usersList) => {
        const usersListFormatted = [];
        for (let i = 0; i < usersList?.length; i++) {
            usersListFormatted.push({
                key: i,
                value: usersList[i].firstname + " " + usersList[i].lastname,
            });
        }
        return usersListFormatted;
    };
 
    const handleSearch = (values) => {
        dispatch(setLoader(true));
 
        setTimeout(() => {
            const filtersToApply = Object.keys(values).reduce((acc, key) => {
                if (values[key] !== null && values[key] !== undefined && values[key] !== '') {
                    acc[key] = values[key];
                }
                return acc;
            }, {});
 
            const createdFrom = filtersToApply.createdDateFrom
                ? dayjs(filtersToApply.createdDateFrom).startOf('day')
                : null;
 
            const createdTo = filtersToApply.createdDateTo
                ? dayjs(filtersToApply.createdDateTo).endOf('day')
                : null;
 
            const deadlinefrom = filtersToApply.deadlinefrom
                ? dayjs(filtersToApply.deadlinefrom).startOf('day')
                : null;
 
            const deadlineto = filtersToApply.deadlineto
                ? dayjs(filtersToApply.deadlineto).endOf('day')
                : null;
 
            const filteredIssues = allIssues.filter(issue => {
                if (filtersToApply.taskID && issue.TaskID.trim().toLowerCase() !== filtersToApply.taskID.trim().toLowerCase()) {
                    return false;
                }
                if (filtersToApply.status?.length > 0 && !filtersToApply.status.includes(issue.Status)) {
                    return false; }
                // Helper to normalize filter value to name if it's an ID
const normalizeFilterValue = (value) => {
    if (!value) return null;
    if (/^[0-9a-fA-F]{24}$/.test(value)) {
        const emp = usersList.find(u => u._id === value);
        return emp ? `${emp.firstname} ${emp.lastname}` : value;
    }
    return value; // already a name
};
 
// Normalize filter values
const filterCreatedBy = normalizeFilterValue(filtersToApply.createdBy);
const filterGuidedBy = normalizeFilterValue(filtersToApply.guidedBy);
const filterAssignedTo = filtersToApply.AssignedTo?.map(normalizeFilterValue) || [];
 
// --- Filtering ---
if (filterCreatedBy) {
    const issueCreatedByName = getEmployeeName(issue.CreatedBy);
    if (issueCreatedByName !== filterCreatedBy) return false;
}
 
if (filterGuidedBy) {
    const issueGuidedByName = getEmployeeName(issue.GuidedBy);
    if (issueGuidedByName !== filterGuidedBy) return false;
}
 
if (filterAssignedTo.length > 0) {
    const assignedNames = (issue.Assignedto || []).map(getEmployeeName);
    const match = assignedNames.some(name => filterAssignedTo.includes(name));
    if (!match) return false;
}
 
 
 
                if (filtersToApply.taskTitle && !issue.TaskTitle?.toLowerCase().includes(filtersToApply.taskTitle.toLowerCase())) {
                    return false;
                }
                if (filtersToApply.Priority && issue.Priority !== filtersToApply.Priority) {
                    return false;
                }
                if ((createdFrom || createdTo) && issue.DateAndTime) {
                    const issueDate = dayjs(parseInt(issue.DateAndTime));
                    if (createdFrom && issueDate.isBefore(createdFrom)) return false;
                    if (createdTo && issueDate.isAfter(createdTo)) return false;
                }
                if ((deadlinefrom || deadlineto) && issue.Deadline) {
                    const issueDeadline = dayjs(parseInt(issue.Deadline));
                    if (deadlinefrom && issueDeadline.isBefore(deadlinefrom)) return false;
                    if (deadlineto && issueDeadline.isAfter(deadlineto)) return false;
                }
 
                return true;
            });
 
            setFilters(filtersToApply);
            setIssues(filteredIssues);
            setPagination(prev => ({ ...prev, current: 1 }));
            dispatch(setLoader(false));
        }, 500);
    };
 
    const handleClearFilters = () => {
        dispatch(setLoader(true));
        filterForm.resetFields();
        setFilters({});
        setIssues(allIssues);
        setPagination(prev => ({ ...prev, current: 1 }));
        dispatch(setLoader(false));
    };
 
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };
 
    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = [];
        const tabName = formData?.Tabname?.trim() || "";
        const TaskTitle = formData?.TaskTitle?.trim() || "";
        const Instructions = formData?.Instructions?.trim() || "";
        const CreatedBy = formData?.CreatedBy?.trim() || "";
        const GuidedBy = formData?.GuidedBy?.trim() || "";
        const Priority = formData?.Priority?.trim() || "";
        const Deadline = formData?.Deadline?.trim() || "";
        const Status = formData?.Status?.trim() || "";
        const Assignedto = formData?.Assignedto || "";
        const issueDesc = formData?.issuedescription?.trim() || "";
 
        if (!TaskTitle) errors.push("Task Title is required.");
        if (!CreatedBy) errors.push("Created By is required.");
        if (!Priority) errors.push("Priority is required.");
        if (!Status) errors.push("Status is required.");
        if (!Assignedto) errors.push("Assigned To is required.");
        if (!issueDesc) errors.push("Task Description is required.");
 
        startTimer();
 
        if (errors.length > 0) {
            message.error(errors.join(" "));
            return;
        }
 
        try {
            dispatch(setLoader(true));
            const currentDateTime = new Date();
 
            await dispatch(createIssueThunk({
                issuedescription: issueDesc,
                Tabname: tabName,
                TaskTitle: TaskTitle,
                CreatedBy: CreatedBy,
                GuidedBy: GuidedBy,
                Instructions: Instructions,
                Status: Status,
                Priority: Priority,
                Assignedto: Assignedto,
                Deadline: Deadline,
                DateAndTime: currentDateTime.toISOString(),
                fileNames: fileData && Array.isArray(fileData) ? fileData.map(file => file.originalName) : [],
                urls: fileData && Array.isArray(fileData) ? fileData.map(file => file.url) : [],
            })).unwrap();
 
            message.success("Task created successfully!");
            setFormData({
                Tabname: "",
                TaskTitle: "",
                issuedescription: "",
                Status: "Not Started",
                Priority: "Low",
                Deadline: "",
                Assignedto: "",
                Remarks: ""
            });
            setFileData(null);
            await fetchAllIssues();
        } catch (error) {
            console.error("Error creating issue:", error);
            message.error("Failed to create task. Please try again.");
        } finally {
            dispatch(setLoader(false));
        }
    };
 
    const handleUpdate = async () => {
        const errors = [];
 
        // Assigned To validation
        if (!editingIssue?.Assignedto) {
            errors.push("Assigned To is required.");
        }
 
        // Additional validations only when status = Completed
        if (editingIssue?.Status === "Completed") {
 
            if (!editingIssue.FinalRemarks?.trim()) {
                errors.push("Final Remarks are required.");
            }
 
            if (
                editingIssue.QualityScore === null ||
                editingIssue.QualityScore === undefined ||
                editingIssue.QualityScore === "" ||
                isNaN(editingIssue.QualityScore)
            ) {
                errors.push("Quality Score is required.");
            }
        }
 
        // --- validation errors check ---
        if (errors.length > 0) {
            return message.error(errors.join(" "));
        }
 
        if (JSON.stringify(editingIssue) === JSON.stringify(originalIssue)) {
            return message.warning("No changes detected. Please update the fields before submitting.");
        }
 
        startTimer();
 
        try {
            dispatch(setLoader(true));
 
            await dispatch(updateIssueThunk({
                _id: editingIssue.id,
                issuedescription: editingIssue.issuedescription,
                CreatedBy: editingIssue.CreatedBy,
                UpdatedDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                GuidedBy: editingIssue.GuidedBy,
                Priority: editingIssue.Priority,
                Deadline: editingIssue.Deadline,
                Tabname: editingIssue.Tabname,
                TaskTitle: editingIssue.TaskTitle,
                Status: editingIssue.Status,
                Assignedto: editingIssue.Assignedto,
                Remarks: editingIssue.Remarks,
                QualityScore: editingIssue.QualityScore ? parseFloat(editingIssue.QualityScore) : null,
                Instructions: editingIssue.Instructions,
                FinalRemarks: editingIssue.FinalRemarks,
            })).unwrap();
 
            message.success("Issue updated successfully!");
            setEditingIssue(null);
            await fetchAllIssues();
 
        } catch (error) {
            console.error("Update Issue Error:", error);
            message.error("Failed to update issue. Please try again.");
        } finally {
            dispatch(setLoader(false));
        }
    };
 
 
    const handleMultipleAttachment = (event) => {
        dispatch(setLoader(true));
        const multipleFiles = Array.from(event.target.files);
        const formData = new FormData();
        multipleFiles.forEach((file) => {
            formData.append('files', file);
        });
 
        axios.post(SERVER_URL + '/upload', formData)
            .then((res) => {
                const uploadedFiles = res.data.files;
                setFileData(uploadedFiles);
                dispatch(setLoader(false));
                message.success("File(s) uploaded successfully.");
            })
            .catch((error) => {
                console.error("File upload error:", error);
                dispatch(setLoader(false));
                message.error("File upload failed.");
            });
    };
 
    function formatDateTime(timestamp) {
        const date = new Date(parseInt(timestamp));
        const formattedDate = date.toLocaleString('en-IN', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
 
        let datee = formattedDate.replace(/\b(am|pm)\b/, match => match.toUpperCase());
        let finalDate = null;
        if (datee === "Invalid Date") {
            finalDate = "-";
        } else {
            finalDate = datee;
        }
 
        return finalDate;
    }
    const exportColumns = [
        'TaskID',
        'Tabname',
        'TaskTitle',
        'issuedescription',
        'CreatedBy',
        'DateAndTime',
        'UpdatedDate',
        'GuidedBy',
        'Priority',
        'Deadline',
        'Status',
        'Assignedto',
        'Remarks',
        'Instructions',
        'HoursSpent',
        'QualityScore',
        'CodeSnippet',
        'TechStack',
        'FinalRemarks',
    ];
 
    const handleExport = (fileFormat, selectedColumns, data) => {
        if (!data || data.length === 0) {
            message.info("No data available for export.");
            return;
        }
 
        const dataToExport = data.map((row, index) => {
            const exportRow = {
                ...row,
                DateAndTime: row.DateAndTime
                    ? dayjs(Number(row.DateAndTime)).isValid()
                        ? dayjs(Number(row.DateAndTime)).format('DD/MM/YYYY hh:mm A')
                        : ''
                    : '',
                UpdatedDate: row.UpdatedDate
                    ? dayjs(Number(row.UpdatedDate)).isValid()
                        ? dayjs(Number(row.UpdatedDate)).format('DD/MM/YYYY hh:mm A')
                        : ''
                    : '',
            };
            return exportRow;
        });
 
        if (fileFormat === 'CSV') {
            const csvData = convertToCSV(dataToExport, selectedColumns);
            downloadCSV(csvData, 'Tasks.csv');
        } else if (fileFormat === 'PDF') {
            simulatePrintDialog(dataToExport, selectedColumns);
        }
    };
 
    const convertToCSV = (data, selectedColumns) => {
        const headers = selectedColumns.join(',') + '\n';
        const rows = data.map(row =>
            selectedColumns.map(col => `"${row[col] ?? ''}"`).join(',')
        );
        return headers + rows.join('\n');
    };
 
    const downloadCSV = (csv, filename) => {
        const blob = new Blob([csv], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
 
    const simulatePrintDialog = (dataToExport, selectedColumns) => {
        const printableContent = document.createElement("div");
        printableContent.id = "print-content";
 
        const table = document.createElement("table");
        table.style.width = "100%";
        table.style.border = "1px solid #000";
        table.style.borderCollapse = "collapse";
 
        const thead = document.createElement("thead");
        const headerRow = document.createElement("tr");
 
        selectedColumns.forEach(col => {
            const th = document.createElement("th");
            th.innerText = col;
            th.style.border = "1px solid #000";
            th.style.padding = "5px";
            headerRow.appendChild(th);
        });
        thead.appendChild(headerRow);
        table.appendChild(thead);
 
        const tbody = document.createElement("tbody");
        dataToExport.forEach(row => {
            const tr = document.createElement("tr");
            selectedColumns.forEach(col => {
                const td = document.createElement("td");
                td.innerText = row[col] || '';
                td.style.border = "1px solid #ccc";
                td.style.padding = "5px";
                tr.appendChild(td);
            });
            tbody.appendChild(tr);
        });
 
        table.appendChild(tbody);
        printableContent.appendChild(table);
 
        const style = document.createElement("style");
        style.innerHTML = `
            body * { visibility: hidden; }
            #print-content, #print-content * { visibility: visible; }
            #print-content { position: absolute; top: 0; left: 0; width: 100%; }
        `;
        document.head.appendChild(style);
        document.body.appendChild(printableContent);
        window.print();
        document.body.removeChild(printableContent);
        document.head.removeChild(style);
    };
 
    const handleDelete = async (record) => {
        Modal.confirm({
            title: "Are you sure you want to delete this issue?",
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            centered: true,
            onOk: async () => {
                try {
                    dispatch(setLoader(true));
                    await dispatch(deleteIssueThunk(record.id)).unwrap();
                    message.success("Issue deleted successfully!");
                    await fetchAllIssues();
                } catch (error) {
                    console.error("Delete Issue Error:", error);
                    message.error("Failed to delete issue. Please try again.");
                } finally {
                    dispatch(setLoader(false));
                }
            },
        });
    };
    const columns = [
        { title: "Task ID", dataIndex: "TaskID", key: "TaskID", render: (text) => text, width: 80, ellipsis: true, },
        { title: "Tabname", dataIndex: "Tabname", key: "Tabname", width: 100, ellipsis: true, },
        { title: "Task Title", dataIndex: "TaskTitle", key: "TaskTitle", width: 150, ellipsis: true, },
       { title: "Created By", dataIndex: "CreatedBy", key: "CreatedBy", render: (id) => getEmployeeName(id),width: 170,ellipsis: true },
        {
            title: "Created Time",
            dataIndex: "DateAndTime",
            key: "DateAndTime",
            render: (text) => formatDateTime(text),
            width: 160,
            ellipsis: true,
        },
        {
            title: "Updated Time",
            dataIndex: "UpdatedDate",
            key: "UpdatedDate",
            render: (text) => formatDateTime(text),
            width: 150,
            ellipsis: true,
        },
       { title: "Guided By", dataIndex: "GuidedBy", key: "GuidedBy", render: (id) => getEmployeeName(id),width: 170,ellipsis: true},
        { title: "Priority", dataIndex: "Priority", key: "Priority", width: 80, ellipsis: true, },
        { title: "Dead Line", dataIndex: "Deadline", key: "Deadline", render: (text) => text ? dayjs(text).format('DD/MM/YYYY') : "N/A", width: 120, ellipsis: true, },
        { title: "Status", dataIndex: "Status", key: "Status", render: (_, record) => record.Status || "", width: 100, ellipsis: true, },
       {
    title: "Assigned To",
    dataIndex: "Assignedto",
    key: "Assignedto",
    render: (arr) => arr?.length ? arr.map(id => getEmployeeName(id)).join(", ") : "—",width: 170,ellipsis: true
},
        { title: "Remarks", dataIndex: "Remarks", key: "Remarks", render: (_, record) => record.Remarks || "N/A", width: 80, ellipsis: true, },
        { title: "Hours Spent", dataIndex: "HoursSpent", key: "HoursSpent", render: (_, record) => record.HoursSpent || "N/A", width: 100, ellipsis: true, },
        { title: "Code Snippet", dataIndex: "CodeSnippet", key: "CodeSnippet", render: (_, record) => record.CodeSnippet || "N/A", width: 100, ellipsis: true, },
        { title: "Tech Stack", dataIndex: "TechStack", key: "TechStack", render: (_, record) => record.TechStack || "N/A", width: 100, ellipsis: true, },
        { title: "Quality Score", dataIndex: "QualityScore", key: "QualityScore", render: (_, record) => record.QualityScore || "N/A", width: 100, ellipsis: true, },
        { title: "Final Remarks", dataIndex: "FinalRemarks", key: "FinalRemarks", render: (_, record) => record.FinalRemarks || "N/A", width: 120, ellipsis: true, },
        {
            title: "Screenshot",
            key: "Screenshot",
            width: 150,
            ellipsis: true,
            render: (_, record) => {
                if (record.urls && record.urls.length > 0 && record.fileNames && record.fileNames.length > 0) {
                    return (
                        <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                            {record.urls.map((url, index) => (
                                <a
                                    key={index}
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {record.fileNames[index] || `File ${index + 1}`}
                                </a>
                            ))}
                        </div>
                    );
                } else {
                    return "No Screenshot";
                }
            },
        },
        {
            title: "Actions",
            key: "actions",
            width: 150,
            render: (_, record) => {
                const isDisabled =
                    (record.Remarks) &&
                    (record.FinalRemarks) &&
                    (record.Instructions);
 
                return (
                    <div style={{ display: "flex", gap: "8px" }}>
                        <span
                            onClick={() => {
                                setSelectedIssue(record);
                                setIsViewModalOpen(true);
                            }}
                            style={{
                                backgroundColor: "#007bff",
                                color: "white",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <FontAwesomeIcon icon={faEye} />
                        </span>
 
                        <span
                            onClick={() => {
                                setRecord(record);
 
                                const updatedRecord = {
                                    ...record,
                                    Instructions: record.Instructions || "",
                                    FinalRemarks: record.FinalRemarks || "",
                                    Remarks: record.Status !== "Completed" ? "" : record.Remarks,
                                };
 
                                setEditingIssue(updatedRecord);
 
                                setOriginalIssue(JSON.parse(JSON.stringify(updatedRecord)));
 
                                setIsChanged(false);
                            }}
 
                            disabled={isDisabled || record.QualityScore || record.FinalRemarks}
                            style={{
                                backgroundColor: (isDisabled || record.QualityScore || record.FinalRemarks) ? "#ccc" : "#007bff",
                                color: "white",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                cursor: (isDisabled || record.QualityScore || record.FinalRemarks) ? "not-allowed" : "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <FontAwesomeIcon
                                icon={record.Status !== "Completed" ? faUserEdit : faCheck}
                            />
                        </span>
 
                        <span
                            onClick={() => handleDelete(record)}
                            style={{
                                backgroundColor: "#007bff",
                                color: "white",
                                padding: "6px 12px",
                                borderRadius: "4px",
                                cursor: "pointer",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </span>
                    </div>
                );
            },
        }
    ];
 
    if (showForm) {
        return (
            <AddIssueForm
                formData={formData}
                setFormData={setFormData}
                assignToUsers={assignToUsers}
                NestedDatabucket={NestedDatabucket}
                LEAD_INFORMATION={LEAD_INFORMATION}
                PRIORITY={PRIORITY}
                getAssignToUsers={getAssignToUsers}
                getOptionsByPath={getOptionsByPath}
                fileData={fileData}
                setFileData={setFileData}
                fileInputRef={fileInputRef}
                handleInputChange={handleInputChange}
                handleMultipleAttachment={handleMultipleAttachment}
                handleSubmit={handleSubmit}
                isDisabled={isDisabled}
                onClose={() => setShowForm(false)}
            />
        );
    }
 
    if (editingIssue) {
        return (
            <EditIssueForm
                editingIssue={editingIssue}
                setEditingIssue={setEditingIssue}
                record={record}
                status={status}
                assignToUsers={assignToUsers}
                NestedDatabucket={NestedDatabucket}
                handleUpdate={handleUpdate}
                onCancel={() => setEditingIssue(null)}
            />
        );
    }
 
    return (
        <div className="page-wrapper">
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '10px',
                    marginBottom: 10,
                    marginTop: -40,
                    marginRight: 10,
                }}
            >
                <AntdButton
                    type="primary"
                    label="Filters"
                    onClick={() => setShowFilters(prev => !prev)}
                    icon={<FontAwesomeIcon icon={faFilter} />}
                />
                <AntdButton
                    type="primary"
                    onClick={() => setShowForm(!showForm)}
                    label="Add New Task"
                />
                <Dropdown
                    overlay={
                        <Menu
                            onClick={({ key }) => handleExport(key, exportColumns, issues)}
                            items={[
                                { key: 'CSV', label: 'Export as CSV' },
                                { key: 'PDF', label: 'Export as PDF' },
                            ]}
                        />
                    }
                    trigger={['click']}
                >
                    <AntdButton
                        type="primary"
                        label="Export"
                        icon={<FontAwesomeIcon icon={faCloudDownload} />}
                    />
                </Dropdown>
            </div>
 
            <div style={{ display: "flex" }}>
                <div style={{ width: "100%" }}>
                    <Row gutter={0}>
                        {showFilters && (
                            <Col span={6} style={{ marginTop: '-60px', marginLeft: '-30px' }}>
                                <AdminTaskFilter
                                    showFilters={showFilters}
                                    onClose={() => setShowFilters(false)}
                                    onSearch={handleSearch}
                                    onClear={handleClearFilters}
                                    form={filterForm}
                                />
                            </Col>
                        )}
 
                        <Col span={showFilters ? 18 : 24} style={{ paddingLeft: 5 }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: 0
                            }}>
                                <h3 style={{ marginLeft: 20 }}>List of Tasks</h3>
                                {Object.keys(filters).length > 0 && (
                                    <span style={{ color: '#666', fontSize: '14px' }}>
                                        Showing {issues.length} filtered results
                                    </span>
                                )}
                            </div>
 
                            <CustomGridTable
                                columns={columns}
                                Id="admin-issues-table"
                                size="small"
                                dataSource={(() => {
                                    const start = (pagination.current - 1) * pagination.pageSize;
                                    const end = pagination.current * pagination.pageSize;
                                    return issues.slice(start, end);
                                })()}
                                pagination={false}
                                rowKey="id"
                                scroll={{ x: 1300 }}
                                enableColumnResize={true}
                                style={{
                                    backgroundColor: "white",
                                    padding: "20px",
                                    borderRadius: "8px",
                                    width: "100%",
                                    maxWidth: "100%",
                                    tableLayout: "auto",
                                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                                }}
                            />
 
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16, marginRight: 10 }}>
                               <Pagination
  current={pagination.current}
  pageSize={pagination.pageSize}
  total={issues.length}
  showSizeChanger
  size="small"
  onChange={(page, pageSize) => {
    setPagination({
      current: page,
      pageSize: pageSize,
    });
  }}
  onShowSizeChange={(current, pageSize) => {
    setPagination({
      current: 1,        // reset to page 1
      pageSize: pageSize,
    });
  }}
/>

                            </div>
                        </Col>
                    </Row>
 
                    <ViewTask
                        open={isViewModalOpen}
                        onClose={closeViewModal}
                        selectedIssue={selectedIssue}
                    />
                </div>
            </div>
        </div>
    );
};
 
export default AdminIssues;